<template>
    <div class="block-editor cache-extend">
        <div class="wrapper">
            <!-- Cache Key -->
            <section>
                <div class="title">{{ $t("Cache Key") }}</div>
                <TiptapEditor
                    :placeholder="$t('Uzatılacak cache key')"
                    :show-attributes="true"
                    v-model="clone.key"
                    automation-mode
                />
                <div class="help-text">
                    <i class="material-icons">info</i>
                    <span>Geçerlilik süresini uzatmak istediğiniz cache'in key'ini girin.</span>
                </div>
            </section>

            <!-- Expires At -->
            <section>
                <div class="title">{{ $t("Yeni Geçerlilik Süresi") }}</div>
                <div class="expires-config">
                    <CustomPicker
                        v-model="clone.expiresAt.mode"
                        :items="expiresModeOptions"
                        idKey="value"
                        labelKey="label"
                        :placeholder="$t('Süre tipi')"
                    />

                    <div v-if="clone.expiresAt.mode === 'duration'" class="duration-config">
                        <TiptapEditor
                            :placeholder="$t('Süre değeri (örn: 24)')"
                            :show-attributes="true"
                            v-model="clone.expiresAt.duration.value"
                            automation-mode
                        />
                        <CustomPicker
                            v-model="clone.expiresAt.duration.unit"
                            :items="durationUnitOptions"
                            idKey="value"
                            labelKey="label"
                            :placeholder="$t('Birim')"
                        />
                    </div>

                    <div v-if="clone.expiresAt.mode === 'timestamp'" class="timestamp-config">
                        <TiptapEditor
                            :placeholder="$t('ISO tarih (örn: 2025-12-31T23:59:59.000Z)')"
                            :show-attributes="true"
                            v-model="clone.expiresAt.timestamp.value"
                            automation-mode
                        />
                    </div>
                </div>
                <div class="help-text">
                    <i class="material-icons">schedule</i>
                    <span>Cache'in yeni geçerlilik süresi şu andan itibaren hesaplanır.</span>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";

export default {
    name: "CacheExtend",
    components: {
        TiptapEditor,
        CustomPicker,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value || {
                key: "",
                expiresAt: {
                    mode: "duration",
                    duration: {
                        value: "1",
                        unit: "hours",
                    },
                    timestamp: {
                        value: "",
                    },
                },
            }),
            expiresModeOptions: [
                { value: "duration", label: "Süre belirt (örn: 24 saat)" },
                { value: "timestamp", label: "Tarih belirt" },
            ],
            durationUnitOptions: [
                { value: "seconds", label: "Saniye" },
                { value: "minutes", label: "Dakika" },
                { value: "hours", label: "Saat" },
                { value: "days", label: "Gün" },
            ],
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.cache-extend {
    .wrapper {
        padding: 30px;

        section {
            margin-bottom: 20px;

            .title {
                margin-bottom: 10px;
                font-weight: 600;
                font-size: 16px;
                line-height: 20px;
            }

            .help-text {
                display: flex;
                align-items: flex-start;
                gap: 8px;
                margin-top: 8px;
                padding: 10px;
                background: #fff3cd;
                border-radius: 6px;
                font-size: 13px;
                color: #856404;

                .material-icons {
                    font-size: 18px;
                    color: #ffc107;
                }
            }

            .expires-config {
                display: flex;
                flex-direction: column;
                gap: 15px;

                .duration-config {
                    display: flex;
                    gap: 10px;
                    align-items: flex-start;

                    > :first-child {
                        flex: 2;
                    }

                    > :last-child {
                        flex: 1;
                    }
                }
            }
        }
    }
}
</style>


